// export const SERVER_URL = 'http://172.27.205.153:8000'; 
export const SERVER_URL = 'https://server.1.strategytracker.net/'; 